/**
 * HttpError.
 */
export class HttpError {
  /**
   * HttpError constructor.
   *
   * @param {object} error - The error.
   *       - response {Object} The http response (or an object).
   */
  constructor({ response = {} }) {
    // send error code 408 on network connexion error
    const statusCode = typeof response === 'undefined' || response.status === 0 ? 408 : response.status;
    let errCode;
    let errMessage;

    if (response && response.data) {
      errCode = response.data.code;
      errMessage = response.data.message;
    }
    this.status = !statusCode ? 503 : statusCode;
    this.code = !errCode ? 0 : errCode;
    this.message = !errMessage ? '' : errMessage;
  }
}
